import { render, staticRenderFns } from "./MyDownloads.vue?vue&type=template&id=13668d4e&scoped=true"
import script from "./MyDownloads.vue?vue&type=script&lang=js"
export * from "./MyDownloads.vue?vue&type=script&lang=js"
import style0 from "./MyDownloads.vue?vue&type=style&index=0&id=13668d4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13668d4e",
  null
  
)

export default component.exports